/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EvidenceItemSource } from './evidenceItemSource';

export interface EvidenceItem {
  /** @maxLength 500 */
  quote: string;
  source: EvidenceItemSource;
  index?: number | null;
}
